
export class GeneralHomePage {

    constructor() {

        //document.ready
        $(() => {


        });

    }

}
